// extracted by mini-css-extract-plugin
export default {"wrapper":"BLp6oadr7qMHSG7U5AV4","placeholder":"VTMzjjvQVkhrfBSVN0Sq"};